import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from './data.service';
@Injectable()
export class ServerTimeService {

  offset?: number;
  synchronized: boolean;

  constructor(private http: HttpClient, private dataService: DataService) {
    this.synchronized = false;
  }

  private readonly getDateTimeNowEndPoint: string = '/setting/getDateTimeNow/';

  async getServerDateTimeNow(): Promise<Date> {
    const params = {};
    return await this.dataService.get<Date>(this.getDateTimeNowEndPoint, params).toPromise();
  }

  async getDateTimeNow(): Promise<Date> {
    if (this.synchronized === false) {
      const serverDate = await this.getServerDateTimeNow();
      const serverTimeMillisGMT = Date.parse(new Date(serverDate).toUTCString());
      const localMillisUTC = Date.parse(new Date().toUTCString());
      this.offset = serverTimeMillisGMT - localMillisUTC;
      this.synchronized = true;
    }

    const date = new Date();
    date.setTime(date.getTime() + this.offset);
    return date;
  }
}
